import { IMAGES } from "../../constants/images";

// Fleet Section - SEO optimized - Mobile Optimized
const FleetSection = () => {
  const vehicles = [
    {
      image: IMAGES.mercedesE,
      category: "Sedan Ejecutivo",
      name: "Mercedes Clase E",
      passengers: "1-3 pax",
      luggage: "3 maletas",
      photos: 3
    },
    {
      image: IMAGES.mercedesE2,
      category: "Sedan Ejecutivo",
      name: "Mercedes Clase E",
      passengers: "1-3 pax",
      luggage: "3 maletas",
      photos: 3
    },
    {
      image: IMAGES.mercedesV,
      category: "Van Premium",
      name: "Mercedes Clase V",
      passengers: "4-7 pax",
      luggage: "7 maletas",
      photos: 1
    },
    {
      image: IMAGES.mercedesS,
      category: "Sedan Lujo",
      name: "Mercedes Clase S",
      passengers: "1-3 pax",
      luggage: "3 maletas",
      photos: 1
    }
  ];

  return (
    <section id="flota" className="py-16 sm:py-24 px-4" data-testid="fleet-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <p className="section-subtitle">Nuestra Flota</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: "'Cinzel', serif" }}>
            Vehículos de <span className="gradient-text">Lujo</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {vehicles.map((vehicle, idx) => (
            <article
              key={idx}
              className="luxury-card overflow-hidden group"
              data-testid={`vehicle-card-${idx}`}
            >
              <div className="relative h-32 sm:h-48 overflow-hidden">
                <img
                  src={vehicle.image}
                  alt={`${vehicle.name} - ${vehicle.category} para transfer VTC Costa del Sol`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                {vehicle.photos > 1 && (
                  <div className="absolute top-2 right-2 sm:top-3 sm:right-3 bg-black/60 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded text-[10px] sm:text-xs">
                    <i className="fas fa-images mr-1"></i>
                    {vehicle.photos}
                  </div>
                )}
                <div className="absolute top-2 left-2 sm:top-3 sm:left-3 bg-[#c9a962] text-[#1a1a2e] px-2 py-0.5 sm:px-3 sm:py-1 rounded text-[9px] sm:text-xs font-semibold">
                  {vehicle.category}
                </div>
              </div>
              <div className="p-3 sm:p-5">
                <h3 className="text-sm sm:text-lg font-semibold mb-1 sm:mb-3" style={{ fontFamily: "'Cinzel', serif" }}>
                  {vehicle.name}
                </h3>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 text-xs sm:text-sm text-gray-400">
                  <span><i className="fas fa-user mr-1 text-[#c9a962]"></i>{vehicle.passengers}</span>
                  <span><i className="fas fa-suitcase mr-1 text-[#c9a962]"></i>{vehicle.luggage}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FleetSection;
